export enum MyLocationFormStep {
  FORM,
  CLEAR_CONFIRM,
  SKIP_CONFIRM,
  CALLBACK_AND_ADDRESS_CONFIRM,
}
